import { splitByCase, titleCase } from 'scule'

export type RecentPage = { path: string; label: string; visitedAt: string }

export const RECENTS_LIMIT = 8

const UNTRACKED_PATHS: Record<string, true> = {
  '/': true,
  '/welcome': true,
  '/dashboard': true,
}

/** Never recorded: '/', '/welcome', '/dashboard', and anything under '/auth/'. */
export const isTrackablePath = (path: string): boolean =>
  !UNTRACKED_PATHS[path] && !path.startsWith('/auth/')

/** Dedupe by exact path, newest first, capped at `limit`. */
export const pushRecent = (
  list: readonly RecentPage[],
  entry: RecentPage,
  limit = RECENTS_LIMIT,
): RecentPage[] =>
  [entry, ...list.filter((recent) => recent.path !== entry.path)].slice(
    0,
    limit,
  )

/** decodeURIComponent, falling back to the raw segment on a malformed %-escape. */
const decodeSegment = (segment: string): string => {
  try {
    return decodeURIComponent(segment)
  } catch {
    return segment
  }
}

/**
 * Display label for a visited path: `metaTitle` when it's a non-empty
 * string, else the last path segment title-cased, else 'Home'. Query/hash
 * are stripped before matching.
 */
export const resolvePageLabel = (path: string, metaTitle?: unknown): string => {
  if (typeof metaTitle === 'string' && metaTitle.length > 0) return metaTitle

  const lastSegment = path.split(/[?#]/)[0]?.split('/').filter(Boolean).at(-1)
  if (!lastSegment) return 'Home'
  return titleCase(splitByCase(decodeSegment(lastSegment)))
}
